import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import SafeIcon from '../../common/SafeIcon';
import { playCowMoo } from '../../common/audioUtils';
import * as FiIcons from 'react-icons/fi';

const { FiCopyright } = FiIcons;

const Layout = () => {
  
  useEffect(() => {
    // Random Cow Moo Logic
    let timerId;

    const scheduleNextMoo = (isFirst = false) => {
      // For the VERY first moo, make it happen sooner (15-45 seconds) so user knows it works
      // Subsequent moos happen every 2-10 minutes
      const minMs = isFirst ? 15 * 1000 : 2 * 60 * 1000;
      const maxMs = isFirst ? 45 * 1000 : 10 * 60 * 1000;
      
      const delay = Math.floor(Math.random() * (maxMs - minMs + 1)) + minMs;
      
      console.log(`🐄 Next Moo scheduled in ${Math.round(delay/1000)} seconds`);

      timerId = setTimeout(() => {
        playCowMoo();
        scheduleNextMoo(false); // Schedule next one with normal long interval
      }, delay);
    };

    // Start the cycle
    scheduleNextMoo(true);

    // Cleanup on unmount
    return () => clearTimeout(timerId);
  }, []);

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900 flex-col transition-colors duration-200">
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900">
            <div className="p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
      
      {/* Footer with Copyright */}
      <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-3 px-6 transition-colors duration-200">
        <div className="flex items-center justify-center text-sm text-gray-600 dark:text-gray-400">
          {/* Easter Egg: Clicking the copyright icon triggers the Moo manually */}
          <button 
            onClick={() => playCowMoo()} 
            className="focus:outline-none hover:text-blue-500 transition-colors cursor-default"
            title="Click for a surprise 🐄"
          >
            <SafeIcon icon={FiCopyright} className="h-4 w-4 mr-1" />
          </button>
          <span>2025 Clark-Ritchotte Communications and Affiliated Companies. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
};

export default Layout;